import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Login from "./Pages/Auth/Login";
import Register from "./Pages/Auth/Register";
import Home from "./Pages/Home";
import Experience from "./Pages/Experience";
import ExperienceDetail from "./Pages/ExperienceDetail";
import MyCart from "./Pages/MyCart";
import Checkout from "./Pages/Checkout";
import MyBookings from "./Pages/MyBookings";
import Dashboard from "./AdminPages/Dashboard";
import AdminLayout from "./AdminComponents/Layout";
import Users from "./AdminPages/Users";
import EditUser from "./AdminPages/Users/EditUser";
import AdminExperience from "./AdminPages/Experience";
import ExperienceCreation from "./AdminPages/Experience/ExperienceCreation";
import Booking from "./AdminPages/Booking";
import Analytics from "./AdminPages/Analytics";
import Payments from "./AdminPages/Payments";
import Barcode from "./AdminPages/Barcode";
import BarcodeCreation from "./AdminPages/Barcode/BarcodeCreation";
import Settings from "./AdminPages/Settings";
import ContactUs from "./Pages/Contact/Contact";
import Profile from "./Pages/Profile/ProfilePage";
import FormFill from "./Pages/FormFill";
import { ToastContainer } from "react-toastify";
import RefundPolicy from "./Pages/RefundPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions";
import ForgotPwd from "./Pages/Auth/ForgotPwd";
import OTP from "./Pages/Auth/OTP";
import NewPwd from "./Pages/Auth/NewPwd";
import TicketCreation from "./AdminPages/Tickets/TicketCreation";
import AdminTickets from "./AdminPages/Tickets";
import AdminCalendar from "./AdminPages/Calendar";
import CalendarCreation from "./AdminPages/Calendar/CalendarCreation";

const isAdminAuthenticated = () => {
  const loginData = JSON.parse(localStorage.getItem("adminData"));
  const token = loginData?.token;
  return token !== null && token !== undefined && token !== "";
};

const isUserAuthenticated = () => {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const token = loginData?.token;
  return token !== null && token !== undefined && token !== "";
};

const ProtectRouteUser = ({ children }) => {
  return isUserAuthenticated() ? children : <Navigate to="/login" />;
};


const ProtectRouteAdmin = ({ children }) => {
  return isAdminAuthenticated() ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* User Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/" element={ <Home />} />
        <Route path="/fillForm" element={<FormFill />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPwd />} />
        <Route path="/otp" element={<OTP />} />
        <Route path="/new-password" element={<NewPwd />} />
        <Route path="/experience" element={<Experience />} />
        <Route path="/experience-detail/:experienceName/:experienceId" element={<ExperienceDetail />} />
        <Route path="/my-cart" element={<MyCart />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/Contact" element={<ContactUs />} />
        <Route path="/profile" element={<ProtectRouteUser><Profile /></ProtectRouteUser>} />
        <Route path="/refund-policy" element={<RefundPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />

        {/* Admin Routes */}
        <Route path="/admin" element={
            <ProtectRouteAdmin>
              <AdminLayout />
            </ProtectRouteAdmin>
          }>
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="edit-user" element={<EditUser />} />
          <Route path="experiences" element={<AdminExperience />} />
          <Route path="experience/:type" element={<ExperienceCreation />} />
          <Route path="tickets" element={<AdminTickets />} />
          <Route path="tickets/:type" element={<TicketCreation />} />
          <Route path="date" element={<AdminCalendar />} />
          <Route path="date/:type" element={<CalendarCreation />} />
          <Route path="booking" element={<Booking />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="payments" element={<Payments />} />
          <Route path="barcode" element={<Barcode />} />
          <Route path="barcode/:type" element={<BarcodeCreation />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
